// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e4528cfa","171":"13b3c7d9","453":"d61660a1","507":"f624a829","889":"9a73c005","949":"11784765"}[chunkId] + ".chunk.js";
};